import React from 'react'
import MatchInfo from '../Component/Info/MatchInfo'

const Info = () => {
  return (
    <div>
      <MatchInfo />
    </div>
  )
}

export default Info
